import { useAuth } from '../../utils/auth/Auth'
import { Avatar, Dropdown, MenuProps, Space, Typography } from 'antd'

const { Text } = Typography

const RightHeader = () => {
  const { logout } = useAuth()
  const { currentUser } = useAuth()

  const items: MenuProps['items'] = [
    {
      key: 2,
      label: <Text>Déconnexion</Text>,
      onClick: logout,
    },
  ]

  return (
    <Space>
      <Dropdown menu={{ items }} placement="bottomLeft" arrow>
        <Avatar
          style={{
            color: '#fff',
            backgroundColor: '#6c7cff',
            cursor: 'pointer',
          }}
        >
          {currentUser && currentUser.firstName && currentUser.lastName
            ? currentUser!.firstName.slice(0, 1) +
              currentUser!.lastName.slice(0, 1)
            : '--'}
        </Avatar>
      </Dropdown>
    </Space>
  )
}

export default RightHeader
